import React from "react";

/**
 * A lightweight, themed loader for the Return Chatbot flow.
 * Uses the same background and spinner style to prevent flickering.
 */
const ReturnChatLoader: React.FC = () => {
    return (
        <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-[#F2F2F2]">
            <div className="tw-animate-spin tw-rounded-full tw-h-8 tw-w-8 tw-border-b-2 tw-border-[#00C5FB]" />
        </div>
    );
};

export default ReturnChatLoader;
